<!--  -->
<template>
  <div class="activeybox">
    <div v-for="element,index in list" :key="index" class="activebox" :style="{ backgroundColor: `${element.backgroundColor}` }" @click="chooser(element.value,element.description)">
      <div
        style="padding:10px;"
        :class="{
          active: +active_id === +element.value ? 'active' : null
        }"
        class="myBox"
      >
        <img :src="element.url" alt="" class="imgaew">
      </div>

      <span>{{ element.description }}</span>
    </div>

  </div>
</template>

<script>
import { acawraccountlist } from '@/api/sourceMaterial.js'
export default {
  components: {},
  props: {
    active_id: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      platformId: null,
      type: null,
      list: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(sendplatformId, type) {
      console.log('send', sendplatformId)
      this.platformId = sendplatformId
      this.type = type
      this.getlistr()
    },
    async getlistr() {
      const data = await acawraccountlist({
        platformId: this.platformId,
        activityType: this.type
      })
      this.list = data.data.theme
      console.log('data', data)
    },
    chooser(val, description) {
      console.log('val', val)
      this.$emit('callbacktemp', val, description)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.activeybox{
  display: flex;
  flex-wrap: wrap;
      height: 680px;
    overflow: hidden;
    overflow-y: scroll;
}
.activebox{
  width: 200px;
  margin: 15px;
  cursor: pointer;
  position: relative;
}
.imgaew{
  width: 100%;
  height: 133px;
}
.region{
  font-size: 12px;
  text-align: center;
  margin-top: 10px;
}
.btn_box{
   width: 100%;
   text-align: center;
   margin-top: 20px;
}
.btn_img{
  width: 100px;
  height: 30px;
}
.saer{
  font-size: 12px;
  margin-top: 10px;
}
.sderas{
  margin-top: 15px;
  padding-left: 15px;
  padding-bottom: 20px;
  box-sizing: border-box;
}
.activityamount{
  position: absolute;
  top: 96px;
  left: 18px;
}

.active{
  background-color: #abcdef;
}

.myBox:not(.active):hover{
   background-color: #abcdef;
}
</style>
